import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=5b11e152&scoped=true&"
import script from "./TopNav.vue?vue&type=script&lang=ts&"
export * from "./TopNav.vue?vue&type=script&lang=ts&"
import style0 from "./TopNav.vue?vue&type=style&index=0&id=5b11e152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b11e152",
  null
  
)

export default component.exports